import Template from '../../component/Template.js';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import useAuth from '../../component/useAuth.js';
import Select from 'react-select'; //04-03-2024-multiselect

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Api from '../../component/Api.js';
import { Link } from 'react-router-dom';
import React, { useRef } from "react";

import 'datatables.net';
import 'datatables.net-bs4/css/dataTables.bootstrap4.min.css';
import $ from 'jquery';
import Group from '@mui/icons-material/Group';
import CheckCircle from '@mui/icons-material/CheckCircle';
import RemoveCircleOutline from '@mui/icons-material/RemoveCircleOutline';

export default function SFAUserMappingLists() {

  const [admissionYears, setAdmissionYears] = useState([]);
  const [admissionYear, setAdmissionYear] = useState(null);

  const [flag, setflag] = useState(false);

  const [semester_id, setSemester] = useState("");


  const tableRef = useRef(null);


  {/*------------------------------------*/ }
  /* CUSTOM DATA TABLE BEGIN HERE */
  const [tableData, setTableData] = useState([]);
  const [tableTotalUsersSFA, setTableTotalUsersSFA] = useState([]);
  const [tableTotalUsersACS, setTableTotalUsersACS] = useState([]);
  const [tableTotalUsersINO, setTableTotalUsersINO] = useState([]);
  const [tableActiveUsersSFA, setTableActiveUsersSFA] = useState([]);
  const [tableActiveUsersACS, setTableActiveUsersACS] = useState([]);
  const [tableActiveUsersINO, setTableActiveUsersINO] = useState([]);
  const [tableInActiveUsersSFA, setTableInActiveUsersSFA] = useState([]);
  const [tableInActiveUsersACS, setTableInActiveUsersACS] = useState([]);
  const [tableInActiveUsersINO, setTableInActiveUsersINO] = useState([]);

  const [sortBy, setSortBy] = useState({ column: null, direction: 'asc' }); //sort
  const [searchQuery, setSearchQuery] = useState('');
  const [filteredAndSortedData, setfilteredAndSortedData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [total_count, setTotal] = useState(null);
  const [loading, setlodaing] = useState(false);
  const [getCollegeTeacherData, setCollegeTeacherData] = useState([]);
  const [reload, setReload] = useState(false);
  const [disciplinedata, setDisciplineData] = useState([]);
  const [disciplineId, setDisciplineId] = useState("");
  const [disciplinetype, setDisciplineTypeChange] = useState(null);
  const [collegedisciplinetype, setCollegeDisciplineTypeChange] = useState(null);

  const [disciplineName, setDisciplineNameChange] = useState(null);
  const [isDeleteUser, setDeleteUser] = useState(false);
  const [deleteUserID, setDeleteUserID] = useState(false);
  const [deleteUserDiscID, setDeleteUserDiscID] = useState(null);
  const [deleteUserCourseType, setDeleteUserCourseType] = useState(null);


  /* CUSTOM DATA TABLE END HERE */


  const { http } = Api();
  const navigate = useNavigate();

  const isAuth = useAuth();
  if (isAuth === false) {
    navigate("/college/");
  }


  let cid = localStorage.getItem("collegeid");
  let collegename = localStorage.getItem("username");

  useEffect(() => {
    const fetchAdmissionYears = async () => {
      try {
        const response = await http.get('/College/getSFASideActiveAdmissionYear');
        const years = response.data.map((year) => ({
          id: year.id,
          value: year.admission_year,
          label: year.admission_year
        }));
        setAdmissionYears(years);
      } catch (error) {
        console.error("Error fetching admission years:", error);
        toast.error("Error fetching admission years:");
      }
    };
    fetchAdmissionYears()


  }, []);

  const handleDisciplineChange = (selectedOption) => {
    //setDisciplineId(selectedOption.value);
    if (selectedOption) {
      setDisciplineId(selectedOption.did);
      setDisciplineNameChange(selectedOption.value);
      setDisciplineTypeChange(selectedOption.type);
      setCollegeDisciplineTypeChange(selectedOption.college_discipline_id);
    }
    else {
      setDisciplineId("");
      setDisciplineNameChange(null);
      setDisciplineTypeChange(null);
      setCollegeDisciplineTypeChange(null);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await http.get(`/College/getCollegeDisciplinesfor_SFA_DEO_Panel`, {
          params: {
            limit: '500',
            college_id: cid
          }
        });

        //setDisciplineData(response.data);
        // ✅ Check if data is an array
        if (Array.isArray(response.data)) {
          setDisciplineData(response.data);
        } else {
          setDisciplineData([]); // fallback to empty array
        }
      }
      catch (error) {
        if (error.response.data.http_status === 401 && error.response.data.status_code == "ERR9") {
          toast.error("Invalid Token");
          setTimeout(() => {
            navigate("/college/");
          }, 5000);

        }
        else if (error.response.data.http_status === 429 && error.response.data.status_code == "ERR33") {
          toast.error(error.response.data.message);
        }
        else {
          toast.error("Something went wrong");
        }
      }
    };

    fetchData();
  }, [reload, cid]);


  useEffect(() => {

    const discipline_id = disciplineId ? disciplineId : null;

    const getCollegeUsersList = async () => {
      try {
        const response = await http.get(`/College/Sfa_Deo_userlist`, {
          params: {
            limit: '500',
            college_id: cid,
            discipline_id: discipline_id,
            college_course_type: disciplinetype
          }
        });
        if (response.data.status_code === 'ERR5') {
          setflag(true);
        }
        //console.log("res", response.data.data);
        setTableData(response.data.data);
        setTableTotalUsersSFA(response.data.summary.total_users_sfa);
        setTableTotalUsersACS(response.data.summary.total_users_acs);
        setTableTotalUsersINO(response.data.summary.total_users_ino);
        setTableActiveUsersSFA(response.data.summary.total_active_users_sfa);
        setTableActiveUsersACS(response.data.summary.total_active_users_acs);
        setTableActiveUsersINO(response.data.summary.total_active_users_ino);
        setTableInActiveUsersSFA(response.data.summary.total_inactive_users_sfa);
        setTableInActiveUsersACS(response.data.summary.total_inactive_users_acs);
        setTableInActiveUsersINO(response.data.summary.total_inactive_users_ino);
      }
      catch (error) {
        if (error.response.data.http_status === 401 && error.response.data.status_code == "ERR9") {
          toast.error("Invalid Token");
          setTimeout(() => {
            navigate("/college/");
          }, 5000);

        }
        else if (error.response.data.http_status === 429 && error.response.data.status_code == "ERR33") {
          toast.error(error.response.data.message);
        }
        else {
          toast.error("Something went wrong");
        }
      }
    };


    getCollegeUsersList();


  }, [semester_id, admissionYear, cid, reload, disciplineId, disciplinetype]);


  /* DATA TABLE  */

  const handleSearchInputChange = (event) => {
    setSearchQuery(event.target.value);
  };

  const handleSort = (column) => {
    const newSortBy = {
      column,
      direction: sortBy.column === column && sortBy.direction === 'asc' ? 'desc' : 'asc',
    };
    setSortBy(newSortBy);
  };


  useEffect(() => {
    const filteredAndSortedData = [...tableData].filter(tableDatas => {
      return (
        (tableDatas.name ?? '').toLowerCase().includes(searchQuery.toLowerCase()) ||
        (tableDatas.email ?? '').toLowerCase().includes(searchQuery.toLowerCase()) ||
        (tableDatas.phone_no ?? '').toLowerCase().includes(searchQuery.toLowerCase()) ||
        (tableDatas.college_course_type ?? '').toString().toLowerCase().includes(searchQuery.toLowerCase()) ||
        (tableDatas.user_type_name ?? '').toString().toLowerCase().includes(searchQuery.toLowerCase()) ||
        (tableDatas.status ?? '').toString().toLowerCase().includes(searchQuery.toLowerCase())

      );
    }).sort((a, b) => {
      if (sortBy.direction === 'asc') {
        return a[sortBy.column] > b[sortBy.column] ? 1 : -1;
      } else {
        return a[sortBy.column] < b[sortBy.column] ? 1 : -1;
      }
    });

    const itemsPerPage = 50;
    const startIndex = (currentPage - 1) * itemsPerPage;
    const paginatedData = filteredAndSortedData.slice(startIndex, startIndex + itemsPerPage);

    setfilteredAndSortedData(paginatedData);
    setTotalPages(Math.ceil(filteredAndSortedData.length / itemsPerPage));
    setTotal(filteredAndSortedData.length);

  }, [searchQuery, sortBy, tableData, currentPage]);

  const renderSortIcon = (columnName) => {
    if (sortBy.column === columnName) {
      return sortBy.direction === 'asc' ? <i className="fa fa-sort-up ml-1" aria-hidden="true"></i> : <i className="fa fa-sort-down ml-1" aria-hidden="true"></i>;
    }
    return <i className="fa fa-sort ml-1" aria-hidden="true"></i>; // Show disabled sort icon
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const handlePreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  /* DATA TABLE END */

  const handleViewDetails = async (admissionYear, semester_id, discipline_id) => {
    setlodaing(true); // assuming you meant `setLoading`

    http
      .get('/College/getCollegerTeacher', {
        params: {
          college_id: cid,
          admissionyear: admissionYear,
          semester_id: semester_id,
          discipline_id: discipline_id
        },
      })
      .then((response) => {
        setCollegeTeacherData(response.data);
      })
      .catch((error) => {
        const status = error.response?.data?.http_status;
        const message = error.response?.data?.message || "An error occurred";

        if (status === 500 || error.response?.data?.status_code === "ERR5") {

          toast.error("No seat names were found");
        } else if (status === 403 && error.response?.data?.status_code === "ERR37") {
          toast.error("Invalid Token");
          setTimeout(() => navigate("/college/"), 5000);
        } else {
          toast.error(message);
        }
      })
      .finally(() => {
        setlodaing(false);
      });
  };

  const encodeYear = yearid => {
    return btoa(yearid);
  };

  const encodeSemID = semid => {
    return btoa(semid);
  };
  const encodeDiscID = discid => {
    return btoa(discid);
  };


  const handleGeneratePDFNew = async () => {
    // setLoading(true);
    try {
      const response = await http.get('/College/Sfa_Deo_userlistpdf_download', {
        params: {
          college_id: cid,
          user_type: 22
        },
        responseType: 'blob', // Expect binary response
      });

      if (response && response.data) {
        // Create a URL for the downloaded file
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;

        // Set the file name and download the PDF
        link.setAttribute(
          'download',
          `${localStorage.getItem('username')}_${collegename}_UsersList.pdf`
        );
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        // setLoading(false);
        toast.success('PDF generated successfully');
      }
    } catch (error) {
      //console.log("error",error);
      // setLoading(false);
      if (error.response.data.http_status === 401 && error.response.data.status_code == "ERR9") {
        toast.error("Invalid Token");
        setTimeout(() => {
          navigate("/college/");
        }, 5000);

      }
      else if (error.response.data.http_status === 500 && error.response.data.status_code == "ERR47") {
        toast.error(error.response.data.message);
      }
      else {
        console.error('Error generating PDF:', error);
        toast.error('Error generating PDF');
      }
    }
  };

  const handleToggleStatus = async (user_id, discipline_id, college_course_type, user_type, status) => {
    const action = status === 'active' ? 'inactive' : 'active';

    try {
      const response = await http.get(`/College/Sfa_Deo_userlist_inactive`, {
        params: {
          user_id: user_id,
          discipline_id: discipline_id,
          discipline_type: college_course_type,
          user_type: user_type,
          action: action
        }
      });

      if (response.data.status_code === 'ERR5') {
        setflag(true);
        return;
      }
      if (response.data.status_code === 'MSG2' || response.data.http_status === 200) {
        toast.success("User status updated successfully");
        setReload(!reload);
      }
    }
    catch (error) {
      if (error.response?.data?.http_status === 401 && error.response.data.status_code === "ERR9") {
        toast.error("Invalid Token");
        setTimeout(() => navigate("/college/"), 5000);
      } else if (error.response?.data?.http_status === 429 && error.response.data.status_code === "ERR33") {
        toast.error(error.response.data.message);
      } else {
        toast.error("Something went wrong");
      }
    }
  };
  const handleClearFields = () => {

    setDisciplineData([]);
    setDisciplineId("");
    setDisciplineTypeChange(null);
    setTableData([]);
    setTableTotalUsersSFA([]);
    setTableTotalUsersACS([]);
    setTableActiveUsersSFA([]);
    setTableActiveUsersACS([]);
    setTableInActiveUsersSFA([]);
    setTableInActiveUsersACS([]);
    setReload(!reload);


  }
  const handleDeleteUser = (userid, discipline_id, college_course_type) => {
    setDeleteUserID(userid);
    setDeleteUserDiscID(discipline_id);
    setDeleteUserCourseType(college_course_type);
    setDeleteUser(true);
  }
  const handleDeleteCancel = () => {
    setDeleteUser(false);
  }


  const handleDeleteSuccess = async () => {
    http
      .post('/College/deleteCollegeUser', {
        college_id: cid,
        userid: deleteUserID,
        discipline_id: deleteUserDiscID,
        college_course_type: deleteUserCourseType
      })
      .then((response) => {
        if (response.data.status_code === "MSG3") {
          setDeleteUser(false);
          sessionStorage.setItem("message", "User deleted successfully");
          toast.success("User data deleted successfully");
          //window.location.reload();
          setReload(!reload);

        }
      })
      .catch((error) => {
        const status = error.response?.data?.http_status;
        const code = error.response?.data?.status_code;
        const message = error.response?.data?.message || "An error occurred";
        setDeleteUser(false);
        if (code === "ERR_COURSE" && status === 500) {
          toast.error("Deletion not allowed. The user has courses that are already approved.");
        } else if (code === "ERR_COURSE2" && status === 500) {
          toast.error("Action not allowed after scripts have been received by your team.");
        } else if (status === 500 || code === "ERR5") {
          toast.error("No user found");
        } else if (status === 403 && code === "ERR37") {
          toast.error("Invalid Token");
          setTimeout(() => navigate("/college/"), 5000);
        } else {
          toast.error(message);
        }
      });
  };


  const customStyles = {
    menu: (provided) => ({
      ...provided,
      maxHeight: '200px',
      overflowY: 'auto',
      textAlign: 'left', // added

    }),
    menuList: (provided) => ({
      ...provided,
      maxHeight: '180px',
      overflowY: 'auto',
      scrollbarWidth: 'thin',
      scrollbarColor: '#888 #f1f1f1',
      textAlign: 'left', // added

    }),

    multiValue: (provided) => ({
      ...provided,
      '&::-webkit-scrollbar': {
        width: '8px',
        textAlign: 'left', // added

      },
      '&::-webkit-scrollbar-track': {
        background: '#f1f1f1',
      },
      '&::-webkit-scrollbar-thumb': {
        background: '#888',
        borderRadius: '4px',
      },
      '&::-webkit-scrollbar-thumb:hover': {
        background: '#555',
      },
    }),
  };

  return (
    <>
      <ToastContainer />
      <Template>
        <div className="container-fluid">
          <div className="row">
            <div className="table-responsive">
              <div className="card">
                <div className="col-md-12">
                  <div className="card-header">
                    <div className="py-3 d-flex justify-content-between align-items-center">
                      <h5>Users</h5>
                    </div>
                  </div>
                  <div className="card-body">
                    {/* <div className="table-responsive"> */}


                    <div className="table-responsive">

                      <div className="row align-items-center pdg18">
                        {/* Left 6 columns */}
                        <div className="col-md-8">
                          <div className="row align-items-center">
                            <div className="col-md-6">
                              <label>Department/Discipline</label>
                              <Select
                                maxMenuHeight={200}
                                menuPlacement="auto"
                                id="discipline_id"
                                name="discipline_id"
                                className="form"
                                placeholder="Select Department/Discipline"
                                isSearchable={true}
                                isClearable={true}
                                styles={customStyles}
                                onChange={handleDisciplineChange}
                                options={flag
                                  ? [{ value: '0', label: 'No data found' }]
                                  : disciplinedata
                                    .sort((a, b) => a.discipline_name.localeCompare(b.discipline_name))
                                    .map(disciplines => ({
                                      did: disciplines.discipline_id,
                                      value: disciplines.discipline_name,
                                      label: disciplines.college_discipline_id == 1
                                        ? `${disciplines.discipline_name} (Single Faculty Course)`
                                        : disciplines.discipline_name,
                                      type: disciplines.college_course_type,
                                      college_discipline_id: disciplines.college_discipline_id
                                    }))
                                }
                                value={
                                  disciplinedata
                                    .map(d => ({
                                      did: d.discipline_id,
                                      value: d.discipline_name,
                                      label: d.college_discipline_id == 1
                                        ? `${d.discipline_name} (Single Faculty Course)`
                                        : `${d.discipline_name}`,
                                      type: d.college_course_type,
                                      college_discipline_id: d.college_discipline_id
                                    }))
                                    .find(option => option.did == disciplineId && option.type == disciplinetype) || null
                                }
                              />
                            </div>

                            <div className="col-md-6 d-flex align-self-end">
                              <button
                                type="button"
                                className="btn btn-secondary clear-btn ms-2"
                                onClick={handleClearFields}
                              >
                                Clear
                              </button>
                            </div>
                          </div>
                        </div>

                        {/* Right 6 columns */}
                        <div className="col-md-4 d-flex justify-content-end">
                          <div className="d-flex gap-2">
                            <Link
                              className="btn custom-btn btn-primary common-btn d-inline-flex align-items-center justify-content-center"
                              to="/college/addusers"
                              title="Add New User"
                            >
                              <i className="bi bi-plus-square ctm-btn-sz m-r-5"></i>New
                            </Link>



                            <button
                              className="btn btn-primary common-btn d-inline-flex align-items-center justify-content-center pdf-btn"
                              onClick={() => handleGeneratePDFNew()}
                              title="Download to PDF"
                            >
                              <i className="bi bi-arrow-down-square ctm-btn-sz"></i>
                            </button>

                          </div>
                        </div>
                      </div>
                      <div className='row'>

                        <div className="col-sm-4">
                          <div className="card small-widget mb-sm-0 bod-line">
                            <div className="card-body primary">
                              <span className="f-light card-fnt-wt">Total</span>
                              <div className="d-flex align-items-end gap-1">
                              </div>
                              <div className="d-flex flex-column mt-1">
                                {/* <span className="f-bold f-light">SFA: {tableTotalUsersSFA ? tableTotalUsersSFA : '0'}</span> */}
                                <span className="f-bold f-light">ACS: {tableTotalUsersACS ? tableTotalUsersACS : '0'}</span>
                                <span className="f-bold f-light">INO: {tableTotalUsersINO ? tableTotalUsersINO : '0'}</span>
                                <span className="f-bold f-light">SFA: {tableTotalUsersSFA ? tableTotalUsersSFA : '0'}</span>

                              </div>
                              <div className="bg-gradient">
                                <svg className="stroke-icon svg-fill">
                                  <Group sx={{ color: '#581f37' }} />
                                </svg>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="col-sm-4">
                          <div className="card small-widget mb-sm-0 bod-line">
                            <div className="card-body primary">
                              <span className="f-light card-fnt-wt">Active</span>
                              <div className="d-flex align-items-end gap-1">
                              </div>
                              <div className="d-flex flex-column mt-1">
                                {/* <span className="f-bold f-light">SFA: {tableActiveUsersSFA ? tableActiveUsersSFA : '0'}</span> */}
                                <span className="f-bold f-light">ACS: {tableActiveUsersACS ? tableActiveUsersACS : '0'}</span>
                                <span className="f-bold f-light">INO: {tableActiveUsersINO ? tableActiveUsersINO : '0'}</span>
                                <span className="f-bold f-light">SFA: {tableActiveUsersSFA ? tableActiveUsersSFA : '0'}</span>

                              </div>
                              <div className="bg-gradient">
                                <svg className="stroke-icon svg-fill">
                                  <CheckCircle sx={{ color: '#581f37' }} />
                                </svg>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="col-sm-4">
                          <div className="card small-widget mb-sm-0 bod-line">
                            <div className="card-body primary"> <span className="f-light card-fnt-wt">Inactive</span>
                              <div className="d-flex align-items-end gap-1">
                              </div>
                              <div className="d-flex flex-column mt-1">
                                {/* <span className="f-bold f-light">SFA: {tableInActiveUsersSFA ? tableInActiveUsersSFA : '0'}</span> */}
                                <span className="f-bold f-light">ACS: {tableInActiveUsersACS ? tableInActiveUsersACS : '0'}</span>
                                <span className="f-bold f-light">INO: {tableInActiveUsersINO ? tableInActiveUsersINO : '0'}</span>
                                <span className="f-bold f-light">SFA: {tableInActiveUsersSFA ? tableInActiveUsersSFA : '0'}</span>

                              </div>
                              <div className="bg-gradient">
                                <svg className="stroke-icon svg-fill">
                                  <RemoveCircleOutline sx={{ color: '#581f37' }} />
                                </svg>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className='row'>

                        <div className='col-md-6 wdt' >
                          <p>
                            Showing {(currentPage - 1) * 50 + 1}{''}-
                            {Math.min((currentPage - 1) * 50 + 50, total_count)} of {total_count} entries
                          </p>
                        </div>
                        <div className='col-md-6 wdt' align='right'>
                          <input
                            type="text"
                            value={searchQuery}
                            onChange={handleSearchInputChange}
                            placeholder="Search..."
                            className='form-control'
                          /></div></div>
                      <div class="table-containerq" style={{ overflowX: 'unset' }}>

                        <table className="display dataTable table-striped table-bordered ex-v-table " ref={tableRef}>
                          <thead>
                            <tr className="bg-primary">

                              <th onClick={() => handleSort('course_id')} scope="col" data-label="APAAR Id" width="8%">Sl No &nbsp;
                                {renderSortIcon('course_id')} </th>
                              <th onClick={() => handleSort('name')} scope="col" data-label="Name " width="">User ID/Name/Email/Phone &nbsp;
                                {renderSortIcon('name')} </th>

                              <th onClick={() => handleSort('college_course_type')} scope="col" data-label="Discipline Type" width="">Department/Discipline Type&nbsp;
                                {renderSortIcon('college_course_type')} </th>
                              <th onClick={() => handleSort('user_type_name')} scope="col" data-label="User Type" width="" > User Type &nbsp;
                                {renderSortIcon('user_type_name')} </th>
                              <th onClick={() => handleSort('status')} scope="col" data-label="Status" width="" > Current Status &nbsp;
                                {renderSortIcon('status')} </th>

                              <th scope="col" data-label="Action" width="">Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            {filteredAndSortedData.length > 0 ? (() => {

                              {/* Old code
                              let prevDiscipline = null;
                              let serialNumber = (currentPage - 1) * 50 + 1;

                              return filteredAndSortedData.map((item, index) => {
                                const isNewGroup = item.discipline_name !== prevDiscipline;
                                prevDiscipline = item.discipline_name;
                                */}

                              // Sort so items of same group (discipline/type/ACS) stay together
                              const sortedData = [...filteredAndSortedData].sort((a, b) => {
                                const keyA = `${a.discipline_name ?? ''}-${a.college_discipline_type ?? ''}-${a.user_type_name ?? ''}`;
                                const keyB = `${b.discipline_name ?? ''}-${b.college_discipline_type ?? ''}-${b.user_type_name ?? ''}`;
                                return keyA.localeCompare(keyB);
                              });

                              // Separate ACS group from others
                              const acsGroup = sortedData.filter(
                                (item) => item.user_type_name === 'ACS' && (!item.discipline_name || item.discipline_name.trim() === '')
                              );
                              const otherGroups = sortedData.filter(
                                (item) => !(item.user_type_name === 'ACS' && (!item.discipline_name || item.discipline_name.trim() === ''))
                              );

                              // Combine ACS first, then others
                              const combinedData = [...acsGroup, ...otherGroups];

                              let prevGroup = null;
                              let serialNumber = (currentPage - 1) * 50 + 1;

                              // Render rows with group headers
                              return combinedData.map((item, index) => {
                                const groupKey =
                                  item.user_type_name === 'ACS' && (!item.discipline_name || item.discipline_name.trim() === '')
                                    ? 'ACS'
                                    : `${item.discipline_id}-${item.discipline_name}-${item.college_discipline_type ?? ''}`;


                                const isNewGroup = groupKey !== prevGroup;
                                prevGroup = groupKey;

                                return (
                                  <React.Fragment key={`${item.id}-${index}`}>
                                    {isNewGroup && (
                                      <tr className="group-header">
                                        <td colSpan="6" className="group-heading">

                                          {
                                            item.user_type_name === 'ACS' && (!item.discipline_name || item.discipline_name.trim() === '') ? (
                                              'Additional Chief Superintendent(ACS)'
                                            ) : item.user_type_name === 'INO' && (!item.discipline_name || item.discipline_name.trim() === '') ? (
                                                'Internship Nodal Officer(INO)'
                                              ) : (
                                                <>
                                                  Discipline: {item.discipline_name} {item.scheme_id === 4 ? '(B.Voc)' : ''} {item.college_discipline_type == 1 ? ' - Single Faculty Course' : ''}
                                                </>
                                              )
                                            }

                                        </td>
                                      </tr>
                                    )}
                                    <tr className="grouped-row">
                                      <td>{serialNumber++}</td>
                                      <td><span style={{color: 'green',fontWeight: 'bold'}}>{item.user_id}</span> <br/>{item.name}<br />{item.email}<br />{item.phone_no}</td>
                                      <td>{item.college_course_type}</td>
                                      <td>{item.user_type_name}</td>
                                      <td style={{ textAlign: 'center' }}>{item.status}</td>
                                      <td>
                                        <div className={`txt-aln ${item.user_type === 22 ? 'togl-sec-2btn' : 'togl-sec'}`}>
                                          {item.user_type === 22 && (
                                            <label className="switch m-l-10" title="Activate/Deactivate User">
                                              <input
                                                type="checkbox"
                                                checked={item.status === 'active'}
                                                onChange={() =>
                                                  handleToggleStatus(
                                                    item.id,
                                                    item.discipline_id,
                                                    item.college_course_type,
                                                    item.user_type,
                                                    item.status
                                                  )
                                                }
                                              />
                                              <span className="slider round"></span>
                                            </label>
                                          )}
                                          <i className="fa fa-trash icn-out-bod" aria-hidden="true"
                                            onClick={() => handleDeleteUser(item.id, item.discipline_id, item.college_course_type)}
                                            style={{ cursor: 'pointer', marginBottom: "10px" }}
                                            title="Delete"></i>
                                        </div>
                                      </td>
                                    </tr>
                                  </React.Fragment>
                                );
                              });
                            })() : (
                              <tr>
                                <td colSpan="7" className="text-center">No data found</td>
                              </tr>
                            )}
                          </tbody>


                        </table>
                      </div>

                      {totalPages > 1 && (
                        <nav aria-label="..." style={{ cursor: "pointer" }}>
                          <ul className="pagination justify-content-center">
                            <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                              <span className="page-link pgn-clr" onClick={handlePreviousPage}><i class="bi bi-arrow-left-circle-fill"></i></span>
                            </li>
                            <li className={`page-item`}>
                              <span className="page-link pgn-clr" onClick={() => handlePageChange(1)}>1</span>
                            </li>
                            {currentPage > 4 && <li className="page-item"><span className="page-link pgn-clr">...</span></li>}
                            {[...Array(totalPages - 1).keys()].slice(currentPage > 4 ? currentPage - 3 : 1, currentPage + 2).map((pageNumber) => (
                              <li key={pageNumber} className={`page-item ${pageNumber + 1 === currentPage ? 'act-clr' : ''}`}>
                                <span className="page-link pgn-clr" onClick={() => handlePageChange(pageNumber + 1)}>{pageNumber + 1}</span>
                              </li>
                            ))}
                            {currentPage < totalPages - 3 && <li className="page-item"><span className="page-link pgn-clr">...</span></li>}

                            <li className={`page-item`}>
                              <span className="page-link pgn-clr" onClick={() => handlePageChange(totalPages)}>{totalPages}</span>
                            </li>

                            <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                              <span className="page-link pgn-clr" onClick={handleNextPage}><i class="bi bi-arrow-right-circle-fill"></i></span>
                            </li>
                          </ul>
                        </nav>
                      )}


                      {/*  Delete User */}
                      <div className={`modal fade show ${isDeleteUser ? 'd-block' : ''}`} id="exampleModalCenter1" tabIndex="-1" role="dialog" aria-labelledby="exampleModalCenter1" aria-model="true">
                        <div className="modal-dialog modal-dialog-centered" role="document">
                          <div className="modal-content">
                            <div className="modal-body">
                              <div className="modal-toggle-wrapper">
                                {/* <ul className="modal-img">
                                  <li> <img src={logo} /></li>
                                </ul> */}
                                <h4 className="text-center pb-2">Are you sure you want to delete?</h4>
                                <p className="text-center">This action cannot be undone. Please confirm if you want to proceed with the deletion.</p>
                                <div className="d-flex justify-content-center mt-3">
                                  <button className="btn btn-danger mx-2" onClick={() => handleDeleteSuccess()}>Delete</button>
                                  <button className="btn " style={{ backgroundColor: 'white', borderColor: 'red', color: 'black' }} data-bs-dismiss="modal" onClick={() => handleDeleteCancel()}>Cancel</button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      {/*  Delete User End */}


                    </div>

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Template>
    </>
  );
}
